import { Field, Float, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { CreditTransaction } from './CreditTransaction'

@InputType()
export class DebitCreditsArgs extends ActionArgs {
  /** Generic owner of the balance — a `User._id` or `Tenant._id`, per `resolveBillingOwnerId`. */
  @Field(() => ID)
  ownerId: string

  /** Positive number of credits to debit — the account balance decreases by this amount. */
  @Field(() => Float)
  credits: number

  @Field(() => String)
  currency: string

  /** Links this Debit back to the `AiUsageRecord` it was charged for. */
  @Field(() => ID)
  usageRecordId: string

  @Field(() => String, { nullable: true })
  feature?: string

  /** Caller-supplied human-readable description of the charge, persisted onto `CreditTransaction.remarks`. */
  @Field(() => String, { nullable: true })
  remarks?: string
}

/**
 * Atomically decrements a `CreditAccount.balance` and records a `Debit` `CreditTransaction`.
 * Module-internal to `ai-node` — injected by class (composed by `RecordAndDebitAiUsage`),
 * never barrel-exported and never bound to an `IocKey` symbol.
 */
export interface IDebitCredits {
  execute(args: DebitCreditsArgs): Promise<CreditTransaction>
}
